import type { RegistrationDictionary } from '@/shared/types';

export const getSumsubStatusButton = (
  registrationDictionaryData: RegistrationDictionary | undefined,
  statusSumSubId: string
) => {
  const status = registrationDictionaryData?.statusSumsub.find(
    status => status.statusId === statusSumSubId
  );

  return status?.statusName;
};
